export const tunnelDefinitions = [
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -0.5,
        y: 0,
      },
      {
        x: -0.1667,
        y: 0,
      },
      {
        x: 0.1667,
        y: 0,
      },
      {
        x: 0.5,
        y: 0,
      },
    ],
    length: 1,
    radius: 0,
    startEndDistance: 1,
    shape: 0,
    svgPath: 'M -0.5,0 C -0.1667,0 0.1667,0 0.5,0',
    svg: '<svg width="25px" height="20px" viewBox="-2.5 -2 5 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -0.5 0 C -0.1667 0 0.1667 0 0.5 0"></path></g></svg>',
    type: 'tunnel1',
    units: 1,
    url: '/assets/tunnels/tunnel1_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -1,
        y: 0,
      },
      {
        x: -0.3333,
        y: 0,
      },
      {
        x: 0.3333,
        y: 0,
      },
      {
        x: 1,
        y: 0,
      },
    ],
    length: 2,
    radius: 0,
    startEndDistance: 2,
    shape: 0,
    svgPath: 'M -1,0 C -0.3333,0 0.3333,0 1,0',
    svg: '<svg width="30px" height="20px" viewBox="-3 -2 6 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1 0 C -0.3333 0 0.3333 0 1 0"></path></g></svg>',
    type: 'tunnel2',
    units: 1,
    url: '/assets/tunnels/tunnel2_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -1.5,
        y: 0,
      },
      {
        x: -0.5,
        y: 0,
      },
      {
        x: 0.5,
        y: 0,
      },
      {
        x: 1.5,
        y: 0,
      },
    ],
    length: 3,
    radius: 0,
    startEndDistance: 3,
    shape: 0,
    svgPath: 'M -1.5,0 C -0.5,0 0.5,0 1.5,0',
    svg: '<svg width="35px" height="20px" viewBox="-3.5 -2 7 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1.5 0 C -0.5 0 0.5 0 1.5 0"></path></g></svg>',
    type: 'tunnel3',
    units: 1,
    url: '/assets/tunnels/tunnel3_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -2,
        y: 0,
      },
      {
        x: -0.6667,
        y: 0,
      },
      {
        x: 0.6667,
        y: 0,
      },
      {
        x: 2,
        y: 0,
      },
    ],
    length: 4,
    radius: 0,
    startEndDistance: 4,
    shape: 0,
    svgPath: 'M -2,0 C -0.6667,0 0.6667,0 2,0',
    svg: '<svg width="40px" height="20px" viewBox="-4 -2 8 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2 0 C -0.6667 0 0.6667 0 2 0"></path></g></svg>',
    type: 'tunnel4',
    units: 1,
    url: '/assets/tunnels/tunnel4_0.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.7958,
    },
    controlPoints: [
      {
        x: -1.5915,
        y: 0,
      },
      {
        x: -1.5916,
        y: -2.1221,
      },
      {
        x: 1.5916,
        y: -2.1221,
      },
      {
        x: 1.5915,
        y: 0,
      },
    ],
    length: 5,
    radius: 1.5915,
    startEndDistance: 3.183,
    shape: 1,
    svgPath: 'M -1.5915,0 C -1.5916,-2.1221 1.5916,-2.1221 1.5915,0',
    svg: '<svg width="35.915px" height="27.958px" viewBox="-3.5915 -3.5915999999999997 7.183 5.5916"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1.5915 0 C -1.5916 -2.1221 1.5916 -2.1221 1.5915 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_1.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.742,
    },
    controlPoints: [
      {
        x: -1.7573,
        y: 0,
      },
      {
        x: -1.4212,
        y: -1.9786,
      },
      {
        x: 1.4212,
        y: -1.9786,
      },
      {
        x: 1.7573,
        y: 0,
      },
    ],
    length: 5,
    radius: 1.7825,
    startEndDistance: 3.5146,
    shape: 2,
    svgPath: 'M -1.7573,0 C -1.4212,-1.9786 1.4212,-1.9786 1.7573,0',
    svg: '<svg width="37.573px" height="27.4195px" viewBox="-3.7573 -3.4839 7.5146 5.4839"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1.7573 0 C -1.4212 -1.9786 1.4212 -1.9786 1.7573 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_2.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.6833,
    },
    controlPoints: [
      {
        x: -1.901,
        y: 0,
      },
      {
        x: -1.2887,
        y: -1.8222,
      },
      {
        x: 1.2887,
        y: -1.8222,
      },
      {
        x: 1.901,
        y: 0,
      },
    ],
    length: 5,
    radius: 2.0054,
    startEndDistance: 3.802,
    shape: 3,
    svgPath: 'M -1.901,0 C -1.2887,-1.8222 1.2887,-1.8222 1.901,0',
    svg: '<svg width="39.01px" height="26.833px" viewBox="-3.901 -3.3666 7.802 5.3666"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1.901 0 C -1.2887 -1.8222 1.2887 -1.8222 1.901 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_3.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.6168,
    },
    controlPoints: [
      {
        x: -2.0329,
        y: 0,
      },
      {
        x: -1.1767,
        y: -1.6448,
      },
      {
        x: 1.1767,
        y: -1.6448,
      },
      {
        x: 2.0329,
        y: 0,
      },
    ],
    length: 5,
    radius: 2.2918,
    startEndDistance: 4.0658,
    shape: 4,
    svgPath: 'M -2.0329,0 C -1.1767,-1.6448 1.1767,-1.6448 2.0329,0',
    svg: '<svg width="40.32899999999999px" height="26.168px" viewBox="-4.0329 -3.2336 8.0658 5.2336"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.0329 0 C -1.1767 -1.6448 1.1767 -1.6448 2.0329 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_4.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.5486,
    },
    controlPoints: [
      {
        x: -2.1433,
        y: 0,
      },
      {
        x: -1.0888,
        y: -1.4629,
      },
      {
        x: 1.0888,
        y: -1.4629,
      },
      {
        x: 2.1433,
        y: 0,
      },
    ],
    length: 5,
    radius: 2.642,
    startEndDistance: 4.2866,
    shape: 5,
    svgPath: 'M -2.1433,0 C -1.0888,-1.4629 1.0888,-1.4629 2.1433,0',
    svg: '<svg width="41.433px" height="25.486px" viewBox="-4.1433 -3.0972 8.2866 5.0972"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.1433 0 C -1.0888 -1.4629 1.0888 -1.4629 2.1433 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_5.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.479,
    },
    controlPoints: [
      {
        x: -2.2356,
        y: 0,
      },
      {
        x: -1.0189,
        y: -1.2773,
      },
      {
        x: 1.0189,
        y: -1.2773,
      },
      {
        x: 2.2356,
        y: 0,
      },
    ],
    length: 5,
    radius: 3.0876,
    startEndDistance: 4.4712,
    shape: 6,
    svgPath: 'M -2.2356,0 C -1.0189,-1.2773 1.0189,-1.2773 2.2356,0',
    svg: '<svg width="42.355999999999995px" height="24.79px" viewBox="-4.2356 -2.958 8.4712 4.958"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.2356 0 C -1.0189 -1.2773 1.0189 -1.2773 2.2356 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_6.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.404,
    },
    controlPoints: [
      {
        x: -2.3164,
        y: 0,
      },
      {
        x: -0.9601,
        y: -1.0774,
      },
      {
        x: 0.9601,
        y: -1.0774,
      },
      {
        x: 2.3164,
        y: 0,
      },
    ],
    length: 5,
    radius: 3.7242,
    startEndDistance: 4.6328,
    shape: 7,
    svgPath: 'M -2.3164,0 C -0.9601,-1.0774 0.9601,-1.0774 2.3164,0',
    svg: '<svg width="43.164px" height="24.04px" viewBox="-4.3164 -2.808 8.6328 4.808"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.3164 0 C -0.9601 -1.0774 0.9601 -1.0774 2.3164 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_7.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.3282,
    },
    controlPoints: [
      {
        x: -2.3812,
        y: 0,
      },
      {
        x: -0.9143,
        y: -0.8752,
      },
      {
        x: 0.9143,
        y: -0.8752,
      },
      {
        x: 2.3812,
        y: 0,
      },
    ],
    length: 5,
    radius: 4.6473,
    startEndDistance: 4.7624,
    shape: 8,
    svgPath: 'M -2.3812,0 C -0.9143,-0.8752 0.9143,-0.8752 2.3812,0',
    svg: '<svg width="43.812px" height="23.281999999999996px" viewBox="-4.3812 -2.6564 8.7624 4.6564"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.3812 0 C -0.9143 -0.8752 0.9143 -0.8752 2.3812 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_8.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.2521,
    },
    controlPoints: [
      {
        x: -2.4309,
        y: 0,
      },
      {
        x: -0.88,
        y: -0.6723,
      },
      {
        x: 0.88,
        y: -0.6723,
      },
      {
        x: 2.4309,
        y: 0,
      },
    ],
    length: 5,
    radius: 6.1115,
    startEndDistance: 4.8618,
    shape: 9,
    svgPath: 'M -2.4309,0 C -0.88,-0.6723 0.88,-0.6723 2.4309,0',
    svg: '<svg width="44.309px" height="22.521px" viewBox="-4.430899999999999 -2.5042 8.861799999999999 4.5042"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.4309 0 C -0.88 -0.6723 0.88 -0.6723 2.4309 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_9.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -2.5,
        y: 0,
      },
      {
        x: -0.8333,
        y: 0,
      },
      {
        x: 0.8333,
        y: 0,
      },
      {
        x: 2.5,
        y: 0,
      },
    ],
    length: 5,
    radius: 0,
    startEndDistance: 5,
    shape: 0,
    svgPath: 'M -2.5,0 C -0.8333,0 0.8333,0 2.5,0',
    svg: '<svg width="45px" height="20px" viewBox="-4.5 -2 9 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.5 0 C -0.8333 0 0.8333 0 2.5 0"></path></g></svg>',
    type: 'tunnel5',
    units: 1,
    url: '/assets/tunnels/tunnel5_0.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.9549,
    },
    controlPoints: [
      {
        x: -1.9099,
        y: 0,
      },
      {
        x: -1.9098,
        y: -2.5464,
      },
      {
        x: 1.9098,
        y: -2.5464,
      },
      {
        x: 1.9099,
        y: 0,
      },
    ],
    length: 6,
    radius: 1.9099,
    startEndDistance: 3.8198,
    shape: 1,
    svgPath: 'M -1.9099,0 C -1.9098,-2.5464 1.9098,-2.5464 1.9099,0',
    svg: '<svg width="39.099px" height="29.549px" viewBox="-3.9099 -3.9097999999999997 7.8198 5.9098"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1.9099 0 C -1.9098 -2.5464 1.9098 -2.5464 1.9099 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_1.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.8877,
    },
    controlPoints: [
      {
        x: -2.116,
        y: 0,
      },
      {
        x: -1.6985,
        y: -2.3673,
      },
      {
        x: 1.6985,
        y: -2.3673,
      },
      {
        x: 2.116,
        y: 0,
      },
    ],
    length: 6,
    radius: 2.1486,
    startEndDistance: 4.232,
    shape: 2,
    svgPath: 'M -2.116,0 C -1.6985,-2.3673 1.6985,-2.3673 2.116,0',
    svg: '<svg width="41.16px" height="28.8775px" viewBox="-4.116 -3.7755 8.232 5.7755"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.116 0 C -1.6985 -2.3673 1.6985 -2.3673 2.116 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_2.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.8129,
    },
    controlPoints: [
      {
        x: -2.2967,
        y: 0,
      },
      {
        x: -1.5328,
        y: -2.1677,
      },
      {
        x: 1.5328,
        y: -2.1677,
      },
      {
        x: 2.2967,
        y: 0,
      },
    ],
    length: 6,
    radius: 2.4351,
    startEndDistance: 4.5934,
    shape: 3,
    svgPath: 'M -2.2967,0 C -1.5328,-2.1677 1.5328,-2.1677 2.2967,0',
    svg: '<svg width="42.967px" height="28.128999999999998px" viewBox="-4.2966999999999995 -3.6258 8.593399999999999 5.6258"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.2967 0 C -1.5328 -2.1677 1.5328 -2.1677 2.2967 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_3.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.726,
    },
    controlPoints: [
      {
        x: -2.4642,
        y: 0,
      },
      {
        x: -1.3918,
        y: -1.9361,
      },
      {
        x: 1.3918,
        y: -1.9361,
      },
      {
        x: 2.4642,
        y: 0,
      },
    ],
    length: 6,
    radius: 2.817,
    startEndDistance: 4.9284,
    shape: 4,
    svgPath: 'M -2.4642,0 C -1.3918,-1.9361 1.3918,-1.9361 2.4642,0',
    svg: '<svg width="44.641999999999996px" height="27.2605px" viewBox="-4.4642 -3.4520999999999997 8.9284 5.4521"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.4642 0 C -1.3918 -1.9361 1.3918 -1.9361 2.4642 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_4.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.6371,
    },
    controlPoints: [
      {
        x: -2.6023,
        y: 0,
      },
      {
        x: -1.2833,
        y: -1.6988,
      },
      {
        x: 1.2833,
        y: -1.6988,
      },
      {
        x: 2.6023,
        y: 0,
      },
    ],
    length: 6,
    radius: 3.2945,
    startEndDistance: 5.2046,
    shape: 5,
    svgPath: 'M -2.6023,0 C -1.2833,-1.6988 1.2833,-1.6988 2.6023,0',
    svg: '<svg width="46.022999999999996px" height="26.3705px" viewBox="-4.6023 -3.2741 9.2046 5.2741"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.6023 0 C -1.2833 -1.6988 1.2833 -1.6988 2.6023 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_5.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.5471,
    },
    controlPoints: [
      {
        x: -2.7149,
        y: 0,
      },
      {
        x: -1.199,
        y: -1.459,
      },
      {
        x: 1.199,
        y: -1.459,
      },
      {
        x: 2.7149,
        y: 0,
      },
    ],
    length: 6,
    radius: 3.9152,
    startEndDistance: 5.4298,
    shape: 6,
    svgPath: 'M -2.7149,0 C -1.199,-1.459 1.199,-1.459 2.7149,0',
    svg: '<svg width="47.149px" height="25.471500000000002px" viewBox="-4.7149 -3.0943 9.4298 5.0943000000000005"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.7149 0 C -1.199 -1.459 1.199 -1.459 2.7149 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_6.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.4559,
    },
    controlPoints: [
      {
        x: -2.8065,
        y: 0,
      },
      {
        x: -1.133,
        y: -1.2158,
      },
      {
        x: 1.133,
        y: -1.2158,
      },
      {
        x: 2.8065,
        y: 0,
      },
    ],
    length: 6,
    radius: 4.7746,
    startEndDistance: 5.613,
    shape: 7,
    svgPath: 'M -2.8065,0 C -1.133,-1.2158 1.133,-1.2158 2.8065,0',
    svg: '<svg width="48.065px" height="24.5595px" viewBox="-4.8065 -2.9119 9.613 4.9119"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.8065 0 C -1.133 -1.2158 1.133 -1.2158 2.8065 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_7.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.3608,
    },
    controlPoints: [
      {
        x: -2.881,
        y: 0,
      },
      {
        x: -1.0808,
        y: -0.9622,
      },
      {
        x: 1.0808,
        y: -0.9622,
      },
      {
        x: 2.881,
        y: 0,
      },
    ],
    length: 6,
    radius: 6.1115,
    startEndDistance: 5.762,
    shape: 8,
    svgPath: 'M -2.881,0 C -1.0808,-0.9622 1.0808,-0.9622 2.881,0',
    svg: '<svg width="48.81px" height="23.6085px" viewBox="-4.881 -2.7217000000000002 9.762 4.7217"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.881 0 C -1.0808 -0.9622 1.0808 -0.9622 2.881 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_8.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.2649,
    },
    controlPoints: [
      {
        x: -2.9367,
        y: 0,
      },
      {
        x: -1.0426,
        y: -0.7064,
      },
      {
        x: 1.0426,
        y: -0.7064,
      },
      {
        x: 2.9367,
        y: 0,
      },
    ],
    length: 6,
    radius: 8.4034,
    startEndDistance: 5.8734,
    shape: 9,
    svgPath: 'M -2.9367,0 C -1.0426,-0.7064 1.0426,-0.7064 2.9367,0',
    svg: '<svg width="49.367000000000004px" height="22.649px" viewBox="-4.9367 -2.5298 9.8734 4.5298"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.9367 0 C -1.0426 -0.7064 1.0426 -0.7064 2.9367 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_9.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -3,
        y: 0,
      },
      {
        x: -1,
        y: 0,
      },
      {
        x: 1,
        y: 0,
      },
      {
        x: 3,
        y: 0,
      },
    ],
    length: 6,
    radius: 0,
    startEndDistance: 6,
    shape: 0,
    svgPath: 'M -3,0 C -1,0 1,0 3,0',
    svg: '<svg width="50px" height="20px" viewBox="-5 -2 10 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -3 0 C -1 0 1 0 3 0"></path></g></svg>',
    type: 'tunnel6',
    units: 1,
    url: '/assets/tunnels/tunnel6_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -1.5,
        y: 0,
      },
      {
        x: -0.5,
        y: 0,
      },
      {
        x: 0.5,
        y: 0,
      },
      {
        x: 1.5,
        y: 0,
      },
    ],
    length: 3,
    radius: 0,
    startEndDistance: 3,
    shape: 0,
    svgPath: 'M -1.5,0 C -0.5,0 0.5,0 1.5,0',
    svg: '<svg width="35px" height="20px" viewBox="-3.5 -2 7 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -1.5 0 C -0.5 0 0.5 0 1.5 0"></path></g></svg>',
    type: 'tunnel1',
    units: 0,
    url: '/assets/tunnels/tunnel1_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -2.5,
        y: 0,
      },
      {
        x: -0.8333,
        y: 0,
      },
      {
        x: 0.8333,
        y: 0,
      },
      {
        x: 2.5,
        y: 0,
      },
    ],
    length: 5,
    radius: 0,
    startEndDistance: 5,
    shape: 0,
    svgPath: 'M -2.5,0 C -0.8333,0 0.8333,0 2.5,0',
    svg: '<svg width="45px" height="20px" viewBox="-4.5 -2 9 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -2.5 0 C -0.8333 0 0.8333 0 2.5 0"></path></g></svg>',
    type: 'tunnel2',
    units: 0,
    url: '/assets/tunnels/tunnel2_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -5,
        y: 0,
      },
      {
        x: -1.6667,
        y: 0,
      },
      {
        x: 1.6667,
        y: 0,
      },
      {
        x: 5,
        y: 0,
      },
    ],
    length: 10,
    radius: 0,
    startEndDistance: 10,
    shape: 0,
    svgPath: 'M -5,0 C -1.6667,0 1.6667,0 5,0',
    svg: '<svg width="70px" height="20px" viewBox="-7 -2 14 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -5 0 C -1.6667 0 1.6667 0 5 0"></path></g></svg>',
    type: 'tunnel3',
    units: 0,
    url: '/assets/tunnels/tunnel3_0.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -6,
        y: 0,
      },
      {
        x: -2,
        y: 0,
      },
      {
        x: 2,
        y: 0,
      },
      {
        x: 6,
        y: 0,
      },
    ],
    length: 12,
    radius: 0,
    startEndDistance: 12,
    shape: 0,
    svgPath: 'M -6,0 C -2,0 2,0 6,0',
    svg: '<svg width="80px" height="20px" viewBox="-8 -2 16 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -6 0 C -2 0 2 0 6 0"></path></g></svg>',
    type: 'tunnel4',
    units: 0,
    url: '/assets/tunnels/tunnel4_0.png',
  },
  {
    centroid: {
      x: 0,
      y: -2.3873,
    },
    controlPoints: [
      {
        x: -4.7746,
        y: 0,
      },
      {
        x: -4.7747,
        y: -6.3662,
      },
      {
        x: 4.7747,
        y: -6.3662,
      },
      {
        x: 4.7746,
        y: 0,
      },
    ],
    length: 15,
    radius: 4.7746,
    startEndDistance: 9.5492,
    shape: 1,
    svgPath: 'M -4.7746,0 C -4.7747,-6.3662 4.7747,-6.3662 4.7746,0',
    svg: '<svg width="67.74600000000001px" height="43.87349999999999px" viewBox="-6.7746 -6.7747 13.5492 8.7747"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -4.7746 0 C -4.7747 -6.3662 4.7747 -6.3662 4.7746 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_1.png',
  },
  {
    centroid: {
      x: 0,
      y: -2.1998,
    },
    controlPoints: [
      {
        x: -5.3421,
        y: 0,
      },
      {
        x: -4.1963,
        y: -5.8661,
      },
      {
        x: 4.1963,
        y: -5.8661,
      },
      {
        x: 5.3421,
        y: 0,
      },
    ],
    length: 15,
    radius: 5.4431,
    startEndDistance: 10.6842,
    shape: 2,
    svgPath: 'M -5.3421,0 C -4.1963,-5.8661 4.1963,-5.8661 5.3421,0',
    svg: '<svg width="73.421px" height="41.998px" viewBox="-7.3421 -6.3996 14.6842 8.3996"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -5.3421 0 C -4.1963 -5.8661 4.1963 -5.8661 5.3421 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_2.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.9464,
    },
    controlPoints: [
      {
        x: -5.9186,
        y: 0,
      },
      {
        x: -3.6797,
        y: -5.1903,
      },
      {
        x: 3.6797,
        y: -5.1903,
      },
      {
        x: 5.9186,
        y: 0,
      },
    ],
    length: 15,
    radius: 6.4458,
    startEndDistance: 11.8372,
    shape: 3,
    svgPath: 'M -5.9186,0 C -3.6797,-5.1903 3.6797,-5.1903 5.9186,0',
    svg: '<svg width="79.18599999999999px" height="39.463499999999996px" viewBox="-7.9186 -5.8927 15.8372 7.8927"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -5.9186 0 C -3.6797 -5.1903 3.6797 -5.1903 5.9186 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_3.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.6713,
    },
    controlPoints: [
      {
        x: -6.3919,
        y: 0,
      },
      {
        x: -3.296,
        y: -4.4568,
      },
      {
        x: 3.296,
        y: -4.4568,
      },
      {
        x: 6.3919,
        y: 0,
      },
    ],
    length: 15,
    radius: 7.7827,
    startEndDistance: 12.7838,
    shape: 4,
    svgPath: 'M -6.3919,0 C -3.296,-4.4568 3.296,-4.4568 6.3919,0',
    svg: '<svg width="83.919px" height="36.713px" viewBox="-8.3919 -5.3426 16.7838 7.3426"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -6.3919 0 C -3.296 -4.4568 3.296 -4.4568 6.3919 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_4.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.4111,
    },
    controlPoints: [
      {
        x: -6.7377,
        y: 0,
      },
      {
        x: -3.034,
        y: -3.7629,
      },
      {
        x: 3.034,
        y: -3.7629,
      },
      {
        x: 6.7377,
        y: 0,
      },
    ],
    length: 15,
    radius: 9.4538,
    startEndDistance: 13.4754,
    shape: 5,
    svgPath: 'M -6.7377,0 C -3.034,-3.7629 3.034,-3.7629 6.7377,0',
    svg: '<svg width="87.37700000000001px" height="34.111000000000004px" viewBox="-8.7377 -4.8222000000000005 17.4754 6.8222000000000005"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -6.7377 0 C -3.034 -3.7629 3.034 -3.7629 6.7377 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_5.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.1527,
    },
    controlPoints: [
      {
        x: -7.0046,
        y: 0,
      },
      {
        x: -2.8408,
        y: -3.074,
      },
      {
        x: 2.8408,
        y: -3.074,
      },
      {
        x: 7.0046,
        y: 0,
      },
    ],
    length: 15,
    radius: 11.7934,
    startEndDistance: 14.0092,
    shape: 6,
    svgPath: 'M -7.0046,0 C -2.8408,-3.074 2.8408,-3.074 7.0046,0',
    svg: '<svg width="90.04599999999999px" height="31.527500000000003px" viewBox="-9.0046 -4.3055 18.0092 6.3055"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.0046 0 C -2.8408 -3.074 2.8408 -3.074 7.0046 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_6.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.8732,
    },
    controlPoints: [
      {
        x: -7.2216,
        y: 0,
      },
      {
        x: -2.6888,
        y: -2.3286,
      },
      {
        x: 2.6888,
        y: -2.3286,
      },
      {
        x: 7.2216,
        y: 0,
      },
    ],
    length: 15,
    radius: 15.8041,
    startEndDistance: 14.4432,
    shape: 7,
    svgPath: 'M -7.2216,0 C -2.6888,-2.3286 2.6888,-2.3286 7.2216,0',
    svg: '<svg width="92.21599999999998px" height="28.732px" viewBox="-9.221599999999999 -3.7464 18.443199999999997 5.7463999999999995"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.2216 0 C -2.6888 -2.3286 2.6888 -2.3286 7.2216 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_7.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.602,
    },
    controlPoints: [
      {
        x: -7.3696,
        y: 0,
      },
      {
        x: -2.5876,
        y: -1.6053,
      },
      {
        x: 2.5876,
        y: -1.6053,
      },
      {
        x: 7.3696,
        y: 0,
      },
    ],
    length: 15,
    radius: 23.157,
    startEndDistance: 14.7392,
    shape: 8,
    svgPath: 'M -7.3696,0 C -2.5876,-1.6053 2.5876,-1.6053 7.3696,0',
    svg: '<svg width="93.696px" height="26.02px" viewBox="-9.3696 -3.2039999999999997 18.7392 5.204"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.3696 0 C -2.5876 -1.6053 2.5876 -1.6053 7.3696 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_8.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.3271,
    },
    controlPoints: [
      {
        x: -7.4618,
        y: 0,
      },
      {
        x: -2.5255,
        y: -0.8724,
      },
      {
        x: 2.5255,
        y: -0.8724,
      },
      {
        x: 7.4618,
        y: 0,
      },
    ],
    length: 15,
    radius: 42.8763,
    startEndDistance: 14.9236,
    shape: 9,
    svgPath: 'M -7.4618,0 C -2.5255,-0.8724 2.5255,-0.8724 7.4618,0',
    svg: '<svg width="94.618px" height="23.2715px" viewBox="-9.4618 -2.6543 18.9236 4.6543"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.4618 0 C -2.5255 -0.8724 2.5255 -0.8724 7.4618 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_9.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -7.5,
        y: 0,
      },
      {
        x: -2.5,
        y: 0,
      },
      {
        x: 2.5,
        y: 0,
      },
      {
        x: 7.5,
        y: 0,
      },
    ],
    length: 15,
    radius: 0,
    startEndDistance: 15,
    shape: 0,
    svgPath: 'M -7.5,0 C -2.5,0 2.5,0 7.5,0',
    svg: '<svg width="95px" height="20px" viewBox="-9.5 -2 19 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.5 0 C -2.5 0 2.5 0 7.5 0"></path></g></svg>',
    type: 'tunnel5',
    units: 0,
    url: '/assets/tunnels/tunnel5_0.png',
  },
  {
    centroid: {
      x: 0,
      y: -3.1831,
    },
    controlPoints: [
      {
        x: -6.3662,
        y: 0,
      },
      {
        x: -6.3662,
        y: -8.4883,
      },
      {
        x: 6.3662,
        y: -8.4883,
      },
      {
        x: 6.3662,
        y: 0,
      },
    ],
    length: 20,
    radius: 6.3662,
    startEndDistance: 12.7324,
    shape: 1,
    svgPath: 'M -6.3662,0 C -6.3662,-8.4883 6.3662,-8.4883 6.3662,0',
    svg: '<svg width="83.66199999999999px" height="51.830999999999996px" viewBox="-8.3662 -8.3662 16.7324 10.3662"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -6.3662 0 C -6.3662 -8.4883 6.3662 -8.4883 6.3662 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_1.png',
  },
  {
    centroid: {
      x: 0,
      y: -2.8478,
    },
    controlPoints: [
      {
        x: -7.3388,
        y: 0,
      },
      {
        x: -5.3932,
        y: -7.5942,
      },
      {
        x: 5.3932,
        y: -7.5942,
      },
      {
        x: 7.3388,
        y: 0,
      },
    ],
    length: 20,
    radius: 7.5758,
    startEndDistance: 14.6776,
    shape: 2,
    svgPath: 'M -7.3388,0 C -5.3932,-7.5942 5.3932,-7.5942 7.3388,0',
    svg: '<svg width="93.38799999999999px" height="48.477999999999994px" viewBox="-9.338799999999999 -7.6956 18.677599999999998 9.695599999999999"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.3388 0 C -5.3932 -7.5942 5.3932 -7.5942 7.3388 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_2.png',
  },
  {
    centroid: {
      x: 0,
      y: -2.5514,
    },
    controlPoints: [
      {
        x: -7.9763,
        y: 0,
      },
      {
        x: -4.835,
        y: -6.8036,
      },
      {
        x: 4.835,
        y: -6.8036,
      },
      {
        x: 7.9763,
        y: 0,
      },
    ],
    length: 20,
    radius: 8.7854,
    startEndDistance: 15.9526,
    shape: 3,
    svgPath: 'M -7.9763,0 C -4.835,-6.8036 4.835,-6.8036 7.9763,0',
    svg: '<svg width="99.763px" height="45.51349999999999px" viewBox="-9.9763 -7.1027 19.9526 9.102699999999999"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -7.9763 0 C -4.835 -6.8036 4.835 -6.8036 7.9763 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_3.png',
  },
  {
    centroid: {
      x: 0,
      y: -2.1887,
    },
    controlPoints: [
      {
        x: -8.5812,
        y: 0,
      },
      {
        x: -4.3491,
        y: -5.8366,
      },
      {
        x: 4.3491,
        y: -5.8366,
      },
      {
        x: 8.5812,
        y: 0,
      },
    ],
    length: 20,
    radius: 10.5997,
    startEndDistance: 17.1624,
    shape: 4,
    svgPath: 'M -8.5812,0 C -4.3491,-5.8366 4.3491,-5.8366 8.5812,0',
    svg: '<svg width="105.81200000000001px" height="41.887px" viewBox="-10.5812 -6.3774 21.1624 8.3774"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -8.5812 0 C -4.3491 -5.8366 4.3491 -5.8366 8.5812 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_4.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.8277,
    },
    controlPoints: [
      {
        x: -9.0453,
        y: 0,
      },
      {
        x: -3.9999,
        y: -4.8739,
      },
      {
        x: 3.9999,
        y: -4.8739,
      },
      {
        x: 9.0453,
        y: 0,
      },
    ],
    length: 20,
    radius: 13.0189,
    startEndDistance: 18.0906,
    shape: 5,
    svgPath: 'M -9.0453,0 C -3.9999,-4.8739 3.9999,-4.8739 9.0453,0',
    svg: '<svg width="110.45299999999999px" height="38.277px" viewBox="-11.0453 -5.6554 22.0906 7.6554"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -9.0453 0 C -3.9999 -4.8739 3.9999 -4.8739 9.0453 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_5.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.4571,
    },
    controlPoints: [
      {
        x: -9.4094,
        y: 0,
      },
      {
        x: -3.7382,
        y: -3.8856,
      },
      {
        x: 3.7382,
        y: -3.8856,
      },
      {
        x: 9.4094,
        y: 0,
      },
    ],
    length: 20,
    radius: 16.6476,
    startEndDistance: 18.8188,
    shape: 6,
    svgPath: 'M -9.4094,0 C -3.7382,-3.8856 3.7382,-3.8856 9.4094,0',
    svg: '<svg width="114.094px" height="34.571px" viewBox="-11.4094 -4.9142 22.8188 6.9142"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -9.4094 0 C -3.7382 -3.8856 3.7382 -3.8856 9.4094 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_6.png',
  },
  {
    centroid: {
      x: 0,
      y: -1.0838,
    },
    controlPoints: [
      {
        x: -9.6796,
        y: 0,
      },
      {
        x: -3.5501,
        y: -2.8902,
      },
      {
        x: 3.5501,
        y: -2.8902,
      },
      {
        x: 9.6796,
        y: 0,
      },
    ],
    length: 20,
    radius: 22.6955,
    startEndDistance: 19.3592,
    shape: 7,
    svgPath: 'M -9.6796,0 C -3.5501,-2.8902 3.5501,-2.8902 9.6796,0',
    svg: '<svg width="116.796px" height="30.8385px" viewBox="-11.6796 -4.1677 23.3592 6.1677"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -9.6796 0 C -3.5501 -2.8902 3.5501 -2.8902 9.6796 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_7.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.7136,
    },
    controlPoints: [
      {
        x: -9.8629,
        y: 0,
      },
      {
        x: -3.4253,
        y: -1.903,
      },
      {
        x: 3.4253,
        y: -1.903,
      },
      {
        x: 9.8629,
        y: 0,
      },
    ],
    length: 20,
    radius: 34.7913,
    startEndDistance: 19.7258,
    shape: 8,
    svgPath: 'M -9.8629,0 C -3.4253,-1.903 3.4253,-1.903 9.8629,0',
    svg: '<svg width="118.62899999999999px" height="27.136px" viewBox="-11.8629 -3.4272 23.7258 5.4272"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -9.8629 0 C -3.4253 -1.903 3.4253 -1.903 9.8629 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_8.png',
  },
  {
    centroid: {
      x: 0,
      y: -0.3369,
    },
    controlPoints: [
      {
        x: -9.9697,
        y: 0,
      },
      {
        x: -3.3536,
        y: -0.8983,
      },
      {
        x: 3.3536,
        y: -0.8983,
      },
      {
        x: 9.9697,
        y: 0,
      },
    ],
    length: 20,
    radius: 74.1025,
    startEndDistance: 19.9394,
    shape: 9,
    svgPath: 'M -9.9697,0 C -3.3536,-0.8983 3.3536,-0.8983 9.9697,0',
    svg: '<svg width="119.697px" height="23.3685px" viewBox="-11.9697 -2.6737 23.9394 4.6737"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -9.9697 0 C -3.3536 -0.8983 3.3536 -0.8983 9.9697 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_9.png',
  },
  {
    centroid: {
      x: 0,
      y: 0,
    },
    controlPoints: [
      {
        x: -10,
        y: 0,
      },
      {
        x: -3.3333,
        y: 0,
      },
      {
        x: 3.3333,
        y: 0,
      },
      {
        x: 10,
        y: 0,
      },
    ],
    length: 20,
    radius: 0,
    startEndDistance: 20,
    shape: 0,
    svgPath: 'M -10,0 C -3.3333,0 3.3333,0 10,0',
    svg: '<svg width="120px" height="20px" viewBox="-12 -2 24 4"><g style="stroke: #d03127; fill: white; stroke-width: 2; stroke-linecap: butt"><path d="M -10 0 C -3.3333 0 3.3333 0 10 0"></path></g></svg>',
    type: 'tunnel6',
    units: 0,
    url: '/assets/tunnels/tunnel6_0.png',
  },
];
